import React from 'react';
import { ProgressSpinner } from 'primereact/progressspinner';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';

const PropertyDatatable = ({ data, loading }) => {
  return (
    <div className="h-full w-full">
      {loading ? (
        <div className="flex items-center justify-center h-full">
          <ProgressSpinner size="large" />
        </div>
      ) : (
        <DataTable
          id={'property-datatable'}
          value={data}
          loading={loading}
          size="small"
          scrollable
          scrollHeight="calc(100vh - 10rem)">
          <Column field="label" header="Propriété"></Column>
          <Column field="count" header="Nombre de résidences"></Column>
          <Column field="percentage" header="Pourcentage"></Column>
        </DataTable>
      )}
    </div>
  );
};

export default PropertyDatatable;
